import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import moment from 'moment';

class RelatedWFMIRecord extends Component {

//TODO: Throw into util
  getDateString = (value) =>
  {
  return (value) ? moment(new Date(value)).format("MM/DD/YYYY h:mm A") : "";
  }

  getYesNo = (value) =>
  {
  return (value && (value === 1 || value === "1")) ? "Yes" : "No";
  }

  render()
  {
    return (
      <Paper elevation={3}>
      <Table size="small">
      <TableBody>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>WFMI ID:</TableCell>
        <TableCell>{this.props.record.WFMIID}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Fire ID:</TableCell>
        <TableCell>{this.props.record.FireId}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Organization:</TableCell>
        <TableCell>{this.props.record.Organization}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Region:</TableCell>
        <TableCell>{this.props.record.RegionState}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Reporting Unit:</TableCell>
        <TableCell>{this.props.record.ReportingUnit}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Calendar Year:</TableCell>
        <TableCell>{this.props.record.CalendarYear}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Fiscal Year:</TableCell>
        <TableCell>{this.props.record.FiscalYear}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Fire Number:</TableCell>
        <TableCell>{this.props.record.FireNumber}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Fire Code:</TableCell>
        <TableCell>{this.props.record.FireCode}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>FireName:</TableCell>
        <TableCell>{this.props.record.FireName}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Fire Type:</TableCell>
        <TableCell>{this.props.record.FireTypeDisplay}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Protection Type:</TableCell>
        <TableCell>{this.props.record.ProtectionTypeDisplay}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Completion Code:</TableCell>
        <TableCell>{this.props.record.CompletionCode}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Index Time:</TableCell>
        <TableCell>{this.props.record.IndexTime}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Index Time Source:</TableCell>
        <TableCell>{this.props.record.IndexTimeSource}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Size Class:</TableCell>
        <TableCell>{this.props.record.SizeClass}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Last Modified:</TableCell>
        <TableCell>{this.props.record.LastModified}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Cause Category:</TableCell>
        <TableCell>{this.props.record.Cause}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Reimbursable:</TableCell>
        <TableCell>{this.props.record.Reimbursable}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Burning Index:</TableCell>
        <TableCell>{this.props.record.BurningIndex}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Area:</TableCell>
        <TableCell>{this.props.record.AreaName}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Owner:</TableCell>
        <TableCell>{this.props.record.OwnerDisplay}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Merged Fire:</TableCell>
        <TableCell>{this.props.record.MergedFire}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Parent Fire:</TableCell>
        <TableCell>{this.props.record.ParentFire}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Origin Accuracy:</TableCell>
        <TableCell>{this.props.record.OriginAccuracy}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Location Method:</TableCell>
        <TableCell>{this.props.record.LocationMethod}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Coordinate Type:</TableCell>
        <TableCell>{this.props.record.CoordinateType}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Datum Type:</TableCell>
        <TableCell>{this.props.record.DatumType}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Latitude DD:</TableCell>
        <TableCell>{this.props.record.LatitudeDD}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Longitude DD:</TableCell>
        <TableCell>{this.props.record.LongitudeDD}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Latitude DMS:</TableCell>
        <TableCell>{this.props.record.LatitudeDMS}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Longitude DMS:</TableCell>
        <TableCell>{this.props.record.LongitudeDMS}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Latitude Entered:</TableCell>
        <TableCell>{this.props.record.LatitudeEntered}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Longitude Entered:</TableCell>
        <TableCell>{this.props.record.LongitudeEntered}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Latitude NAD83:</TableCell>
        <TableCell>{this.props.record.LatitudeNAD83}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Longitude NAD83:</TableCell>
        <TableCell>{this.props.record.LongitudeNAD83}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Utm Zone:</TableCell>
        <TableCell>{this.props.record.UtmZone}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Utm Easting:</TableCell>
        <TableCell>{this.props.record.UtmEasting}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Utm Northing:</TableCell>
        <TableCell>{this.props.record.UtmNorthing}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Start Time:</TableCell>
        <TableCell>{this.props.record.StartTime}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Detection:</TableCell>
        <TableCell>{this.props.record.DetectionDisplay}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Start Acres:</TableCell>
        <TableCell>{this.props.record.StartAcres}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Initial Attack Time:</TableCell>
        <TableCell>{this.props.record.InitialAttackTime}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Initial Attack Acres:</TableCell>
        <TableCell>{this.props.record.InitialAttackAcres}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Contained Time:</TableCell>
        <TableCell>{this.props.record.ContainedTime}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Contained Acres:</TableCell>
        <TableCell>{this.props.record.ContainedAcres}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Control Time:</TableCell>
        <TableCell>{this.props.record.ControlTime}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Control Acres:</TableCell>
        <TableCell>{this.props.record.ControlAcres}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Out Date:</TableCell>
        <TableCell>{this.props.record.OutDate}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Easting:</TableCell>
        <TableCell>{this.props.record.UtmEasting}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Topography:</TableCell>
        <TableCell>{this.props.record.TopographyDisplay}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Aspect:</TableCell>
        <TableCell>{this.props.record.AspectDisplay}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Slope:</TableCell>
        <TableCell>{this.props.record.SlopeDisplay}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Elevation:</TableCell>
        <TableCell>{this.props.record.ElevationDisplay}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Station:</TableCell>
        <TableCell>{this.props.record.Station}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Fuel Model:</TableCell>
        <TableCell>{this.props.record.FbpsFuelModel}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Msgc Model:</TableCell>
        <TableCell>{this.props.record.MsgcModelDisplay}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Msgc Slope:</TableCell>
        <TableCell>{this.props.record.MsgcSlope}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Msgc Grass:</TableCell>
        <TableCell>{this.props.record.MsgcGrassDisplay}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Msgc Climate:</TableCell>
        <TableCell>{this.props.record.MsgcClimateDisplay}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Special Area:</TableCell>
        <TableCell>{this.props.record.SpecialArea}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Wildland Urban:</TableCell>
        <TableCell>{this.props.record.WildlandUrban}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Intersect Fuels:</TableCell>
        <TableCell>{this.props.record.IntersectFuels}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Add To NFPORS:</TableCell>
        <TableCell>{this.props.record.AddToNFPORS}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Total Structures:</TableCell>
        <TableCell>{this.props.record.TotalStructures}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Residence Structures:</TableCell>
        <TableCell>{this.props.record.ResidenceStructures}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Other Structures:</TableCell>
        <TableCell>{this.props.record.OtherStructures}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Authorized By Name:</TableCell>
        <TableCell>{this.props.record.AuthorizedByName}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Authorized By Title:</TableCell>
        <TableCell>{this.props.record.AuthorizedByTitle}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Authorized Date:</TableCell>
        <TableCell>{this.props.record.AuthorizedDate}</TableCell>
      </TableRow>

      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Entered By Name:</TableCell>
        <TableCell>{this.props.record.EnteredByName}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Entered By Title:</TableCell>
        <TableCell>{this.props.record.EnteredByTitle}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Entered Date:</TableCell>
        <TableCell>{this.props.record.EnteredDate}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Provided By Name:</TableCell>
        <TableCell>{this.props.record.ProvidedByName}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Provided By Title:</TableCell>
        <TableCell>{this.props.record.ProvidedByTitle}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Provided Date:</TableCell>
        <TableCell>{this.props.record.ProvidedDate}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Trespass General Cause:</TableCell>
        <TableCell>{this.props.record.TrespassGeneralCauseDisplay}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Trespass Specific Cause:</TableCell>
        <TableCell>{this.props.record.TrespassSpecificCauseDisplay}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Trespass Investigated:</TableCell>
        <TableCell>{this.props.record.TrespassInvestigated}</TableCell>
        <TableCell style={{fontWeight:"bold"}}></TableCell>
        <TableCell></TableCell>
      </TableRow>

      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Statistics 1 Owner</TableCell>
        <TableCell>{this.props.record.Statistics1OwnerDisplay}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Statistics 1 Acres</TableCell>
        <TableCell>{this.props.record.Statistics1Acres}</TableCell>
      </TableRow>

      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Statistics 2 Owner</TableCell>
        <TableCell>{this.props.record.Statistics2OwnerDisplay}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Statistics 2 Acres</TableCell>
        <TableCell>{this.props.record.Statistics2Acres}</TableCell>
      </TableRow>

      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Statistics 3 Owner</TableCell>
        <TableCell>{this.props.record.Statistics3OwnerDisplay}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Statistics 3 Acres</TableCell>
        <TableCell>{this.props.record.Statistics3Acres}</TableCell>
      </TableRow>

      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Statistics 4 Owner</TableCell>
        <TableCell>{this.props.record.Statistics4OwnerDisplay}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Statistics 4 Acres</TableCell>
        <TableCell>{this.props.record.Statistics4Acres}</TableCell>
      </TableRow>

      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Statistics 5 Owner</TableCell>
        <TableCell>{this.props.record.Statistics5OwnerDisplay}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Statistics 5 Acres</TableCell>
        <TableCell>{this.props.record.Statistics5Acres}</TableCell>
      </TableRow>

      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Statistics 6 Owner</TableCell>
        <TableCell>{this.props.record.Statistics6OwnerDisplay}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Statistics 6 Acres</TableCell>
        <TableCell>{this.props.record.Statistics6Acres}</TableCell>
      </TableRow>

      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Statistics 7 Owner</TableCell>
        <TableCell>{this.props.record.Statistics7OwnerDisplay}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Statistics 7 Acres</TableCell>
        <TableCell>{this.props.record.Statistics7Acres}</TableCell>
      </TableRow>

      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Remarks</TableCell>
        <TableCell colSpan={3}>{this.props.record.Remarks}</TableCell>
      </TableRow>


      </TableBody>
      </Table>
      </Paper>
  )
  }
}

export default RelatedWFMIRecord;
